import { app } from '@lib';

export default {
  // 新增/编辑物品
  commodityGoods(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/commodityGoods',
      params,
    });
  },
  // 删除
  delCommodityGoods(params) {
    return app.http.ajax({
      method: 'delete',
      url: '/api/cs-pc-edu/commodityGoods',
      params,
    });
  },
  // 物品列表
  queryCommodityGoodsList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/commodityGoods/page',
      params,
    });
  },
  // 物品详情
  getCommodityGoodDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/commodityGoods/get',
      params,
    });
  },
  // 启用/停用
  enableOrDisableCommodityGoods(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/commodityGoods/enableOrDisableCommodityGoods',
      params,
    });
  },
  // 合同模板导入
  importContractTemplate(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/templateUpload',
      params,
    });
  },
  // 合同模板列表
  getContractTemplateList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/templateList',
      params,
    });
  },
  // 合同模板设置校区
  updateContractTemplateCampus(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/templateCampusRelevance',
      params,
    });
  },
  // 删除合同模版
  delContractTemplate(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/templateDelete',
      params,
    });
  },
  // 合同列表
  contractList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/contractList',
      params,
    });
  },
  // 合同详情
  contractDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/contract/detail',
      params,
    });
  },
  // 模版预览
  templatePreview(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/contract/templatePreview',
      params,
    });
  },
  // 推送给家长
  pushParent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/pushParent',
      params,
    });
  },
  // 生成合同模板列表
  createContract(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/createContract',
      params,
    });
  },
  // 生成合同二维码
  createContractQrCode(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/contract/createQrCode',
      params,
    });
  },
  // 精彩瞬间设备列表
  cameraList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/momentCamera/cameraList',
      params,
    });
  },
  // 精彩瞬间设备绑定
  cameraBind(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/momentCamera/cameraBind',
      params,
    });
  },
  // 获取视频类型列表
  videoTypeList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/videoType/list',
      params,
    });
  },
  // 修改视频类型
  videoTypeEdit(params) {
    return app.http.ajax({
      method: 'put',
      url: '/api/cs-pc-edu/videoType/edit',
      params,
    });
  },
  // 增加视频类型
  videoTypeAdd(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/videoType/add',
      params,
    });
  },
  // 删除视频类型
  videoTypeDelete(params) {
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-edu/videoType/delete?videoTypeId=${params.videoTypeId}`,
    });
  },
  // 获取视频列表
  videoList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/video/list',
      params,
    });
  },
  // 编辑视频
  editVideos(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/editVideos',
      params,
    });
  },
  // 删除视频
  deleteVideos(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/deleteVideos',
      params,
    });
  },
  // 查询单个班级
  getClassInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/classInfo',
      params,
    });
  },
  // 基础定价维度
  getBasePriceDimension(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/basePriceDimension/page',
      params,
    });
  },
  // 批量延后
  batchDelayArrange(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchDelay',
      params,
    });
  },
  // 批量修改上课时间
  batchModifyCourseTime(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyCourseTime',
      params,
    });
  },
  // 批量修改上课老师
  batchModifyCourseTeacher(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyCourseTeacher',
      params,
    });
  },
  // 批量修改上课教室
  batchModifyCourseClassRoom(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyCourseClassRoom',
      params,
    });
  },
  // 批量修改上课课消数
  batchModifyCourseAmount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyCourseAmount',
      params,
    });
  },
  // 批量修改备注
  batchModifyRemark(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyRemark',
      params,
    });
  },
  // 批量删除课次
  batchDeleteArrange(params) {
    return app.http.ajax({
      method: 'delete',
      url: '/api/cs-pc-edu/arrange/batchDelete',
      params,
    });
  },
  // 删除当前课次
  deleteArrange(params) {
    return app.http.ajax({
      method: 'delete',
      url: `/api/cs-pc-edu/arrange?courseArrangeId=${params.courseArrangeId}`,
    });
  },
  // 取消排课
  suspendClasses(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/suspendClasses',
      params,
    });
  },
  // 恢复排课
  cancelSuspendClasses(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/cancelSuspendClasses',
      params,
    });
  },
  // 同课价转班
  transferClass(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/transferClass',
      params,
    });
  },
  // 同课价转班-批量
  multipleTransferClass(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/transferClassBatch',
      params,
    });
  },
  // 新增课程
  addCourseName(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/curriculum/addCurriculumInfo',
      params,
    });
  },
  // 新增课程
  addPriceItem(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/curriculum/addCurriculumPriceItems',
      params,
    });
  },
  // 删除课程
  deleteCourse(params) {
    return app.http.ajax({
      method: 'delete',
      url: `/api/cs-pc-edu/curriculum/deleteCurriculum?curriculumId=${params.curriculumId}`,
    });
  },
  // 删除课价
  deletePriceItem(params) {
    return app.http.ajax({
      method: 'delete',
      url: `/api/cs-pc-edu/priceItem?curriculumId=${params.curriculumId}&priceItemId=${params.priceItemId}`,
    });
  },
  // 修改课程名称
  editCourseName(params) {
    return app.http.ajax({
      method: 'put',
      url: '/api/cs-pc-edu/curriculum/editCurriculumInfo',
      params,
    });
  },
  // 获取课程详情
  getCurriculumInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/curriculum/getCurriculumInfo',
      params,
    });
  },
  // 修改课价
  editPriceItem(params) {
    return app.http.ajax({
      method: 'put',
      url: '/api/cs-pc-edu/curriculum/editCurriculumPriceItem',
      params,
    });
  },
  // 同课价班级列表
  classByPriceItemIdPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/classByPriceItemId/page',
      params,
    });
  },
  storeCardActivityList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/queryList',
      params,
    });
  },
  storeCardActivityAdd(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/add',
      params,
    });
  },
  storeCardActivityUpdate(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/update',
      params,
    });
  },
  storeCardActivityDelete(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/delete',
      params,
    });
  },
  storeCardActivityUpdateSaleStatus(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/updateSaleStatus',
      params,
    });
  },
  queryStoreCardActivity(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storeCardActivity/queryStoreCardActivity',
      params,
    });
  },
  queryStoredCardAccountDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardAccount/queryStoredCardAccountDetail',
      params,
    });
  },
  updateStoredCardAccountDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardAccount/updateStoredCardAccountDetail',
      params,
    });
  },
  queryStoredCardStudent(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/storedCardStudent/queryStoredCardStudent',
      params,
    });
  },
  storedCardBindStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardStudent/storedCardBindStudent',
      params,
    });
  },
  manualDeduction(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCard/manualDeduction',
      params,
    });
  },
  queryStoredCardTransactionListById(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCard/queryStoredCardTransactionListById',
      params,
    });
  },
  queryStoredCardOperatorLogListById(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardOperatorLog/queryStoredCardOperatorLogListById',
      params,
    });
  },
  // 可视化排课详情
  getArrangeDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/arrange/getDetail',
      params,
    });
  },
  // 课节详情
  arrangeDetail(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/arrange?arrangeRecordId=${id}`,
    });
  },
  // 添加排课计划_杨武
  courseArrangePlanAdd(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseArrangePlan',
      params,
    });
  },
  // 同课程学员列表
  findStudentsByCurriculumId(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/findStudentsByCurriculumId',
      params,
    });
  },
  // 常用排课时段列表
  courseArrangeTimeTempList() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/courseArrangeTimeTemp/list',
    });
  },
  // 排课冲突检测-教室列表
  arrangeClassRoomList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/classRoom/list',
      params,
    });
  },
  // 排课冲突检测-老师列表
  arrangeTeacherList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/teacher/getChooseTeacherList',
      params,
    });
  },
  // 编辑单节排课-刘鹏
  modifySingleCourseArrange(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/modifySingleCourseArrange',
      params,
    });
  },
  // 查看课表列表
  arrangePage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/page',
      params,
    });
  },
  // 添加排课计划预览信息
  courseArrangePlanPreview(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseArrangePlan/preview',
      params,
    });
  },
  // 获取单节课的学员列表
  getCourseStudents(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/courseSign/getCourseStudents?courseArrangeId=${id}`,
    });
  },
  // 删除排课中的学员
  deleteStudentInCourseArrange(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/deleteStudentInCourseArrange',
      params,
    });
  },
  // 排课添加学员
  addStudentInCourseArrange(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/addStudentInCourseArrange',
      params,
    });
  },
  // 新增试听
  auditionAdd(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/audition',
      params,
    });
  },
  // 缺勤列表
  courseAbsentList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseAbsent/list',
      params,
    });
  },
  // 安排补课
  courseRemedyAddRemedy(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseRemedy/addRemedy',
      params,
    });
  },
  // 班级添加学员列表
  findClassAddStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/findClassAddStudent',
      params,
    });
  },
  // 学员管理恢复为在读-毛新武
  setStudentRestoreStudy(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/becomeStudy',
      params,
    });
  },
  // 学员管理转为曾就读-毛新武
  setStudentHistory(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/becomeHistory',
      params,
    });
  },
  // 学员管理停课-毛新武
  setStudentSuspendCourse(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/studentSuspendCourse',
      params,
    });
  },
  // 学员管理复课-毛新武
  setStudentRecoveryCourse(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/studentRecoveryCourse',
      params,
    });
  },
  // 学员查看停复课信息-毛新武
  getStudentSuspendDetail(studentId) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/student/getStudentSuspendDetail?studentId=${studentId}`,
    });
  },
  // 学员卡包列表-封杰
  getStudentCardList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/studentCard/list',
      params,
    });
  },
  // 费用预警开启/关闭-封杰
  setFeeWarn(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/courseFeeWarn/tagCardCourseTradedFeeWarn',
      params,
    });
  },
  // 修改课程有效期-封杰
  editFeeExpireTime(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/editFeeExpireTime',
      params,
    });
  },
  // 编辑计费时段-封杰
  editChargeRule(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/editChargeRule',
      params,
    });
  },
  // 查询收费记录-封杰
  findChargeRecordOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/findChargeRecordOrder',
      params,
    });
  },
  // 不在上课/继续上课-封杰
  editCourseStudentStatus(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseStudent/edit/batch',
      params,
    });
  },
  // 学员就读课程-封杰
  getStudentAttendCourseList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseStudent/findStudentAttendCourse',
      params,
    });
  },
  // 学员入班-封杰
  stuIntoClass(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/intoClassMulti',
      params,
    });
  },
  // 删除学员-毛新武
  delStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/delete',
      params,
    });
  },
  // 发送学员人脸录入-毛新武
  sendFaceAddReminder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/sendFaceAddReminder',
      params,
    });
  },
  // 批量转曾就读-毛新武
  batchBecomeHistory(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/batchBecomeHistory',
      params,
    });
  },
  // 获取班级列表分页-封杰
  queryClassList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/page',
      params,
    });
  },
  // 获取班级列表分页-封杰
  queryClassInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/classInfo/getClassInfoVo',
      params,
    });
  },
  // 新增班级-封杰
  createClassInfoUsingPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo',
      params,
    });
  },
  // 编辑班级-封杰
  updateClassInfoUsingPOST(params) {
    return app.http.ajax({
      method: 'put',
      url: '/api/cs-pc-edu/classInfo',
      params,
    });
  },
  // 批量修改约课设置
  batchModifyReserveSetting(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/arrange/batchModifyReserveSetting',
      params,
    });
  },
  // 批量编辑-封杰
  muitlueUpdateClassInfoPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/batchEditClassInfo',
      params,
    });
  },
  // 删除班级-封杰
  deleteClassInfo(params) {
    return app.http.ajax({
      method: 'delete',
      url: `/api/cs-pc-edu/classInfo?classId=${params}`,
    });
  },
  // 班级详情-学员列表-封杰
  getClassInfoStudentPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/queryClassStudentList',
      params,
    });
  },
  // 班级管理-结班-封杰
  classCompletionPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-edu/classInfo/classCompletion?classId=${params}`,
    });
  },
  // 班级管理-撤销结班-封杰
  cancelClassCompletionPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-edu/classInfo/cancelClassCompletion?classId=${params}`,
    });
  },
  // 班级管理-出班-封杰
  setOutClassPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/outOfClass',
      params,
    });
  },
  // 班级管理-批量出班-封杰
  setMultipleOutClassPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/outOfClassBatch',
      params,
    });
  },
  // 班级管理-入班-封杰
  setIntoClassPOST(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/intoClass',
      params,
    });
  },
  // 班级管理-更改出入班日期-封杰
  updateInOutDate(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/updateInOutDate',
      params,
    });
  },
  // 班级管理-查询学员指定班级的进出班记录-封杰
  findClassStudentRecordsGet(params) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/classStudent/findClassStudentRecords?classId=${params.classId}&studentId=${params.studentId}`,
    });
  },
  // 班级排课统计
  // getClassCourseArrangeStat(params) {
  //   return app.http.ajax({
  //     method: 'post',
  //     url: '/api/cs-pc-edu/classInfo/getClassCourseArrangeStat',
  //     params,
  //   });
  // },
  // 获取学员可用复入班时间_龙耀东
  findInClassValidDate(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/classStudent/findInClassValidDate',
      params,
    });
  },
  // 计算实付金额_龙耀东
  calculatePayFact(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/utils/calculate/payFact',
      params,
    });
  },
  // 查课程价目详情_龙耀东
  getPriceItemDetail(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/curriculum/getPriceItemDetail?priceItemId=${id}`,
    });
  },
  // 下单_龙耀东
  frontDeskCharge(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/frontDeskCharge',
      params,
    });
  },
  // 支付渠道_龙耀东
  // paymentAccountList(params) {
  //   return app.http.ajax({
  //     method: 'post',
  //     url: '/api/cs-pc-edu/paymentAccount/list',
  //     params,
  //   });
  // },
  // 获取订单详情_张逸玮
  orderInfoGet(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/orderInfo/get',
      params,
    });
  },
  // 收据_杨武
  findReceipt(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/public/receipt/findReceipt',
      params,
    });
  },
  // 获取订单项目详情_杨武
  getOrderItems(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/getOrderItems',
      params,
    });
  },
  // 检查是否开通商户_张逸玮
  checkCompanyMerchant() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/paymentAccount/checkCompanyMerchant',
    });
  },
  // 支付_张逸玮
  orderPayment(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/payment',
      params,
    });
  },
  // 钱包充值_龙耀东
  eWalletRecharge(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/walletRecharge',
      params,
    });
  },
  // 根据机构手机号查询机构下的储值卡开卡手机号和持卡人姓名
  getCardholderInfos(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardAccount/getCardholderInfos',
      params,
    });
  },
  // 查询机构下的所有储值卡活动
  getActivityPromoDetails(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/storeCardActivity/getActivityPromoDetails',
      params,
    });
  },
  // 收费类型_龙耀东
  orderFlagList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderFlag/list',
      params,
    });
  },
  // 获取收款账户列表
  getPaymentAccountList() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/paymentAccount/list',
    });
  },
  // 发送订单给家长--龙耀东
  sendOrderInfoMsg(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseFeeWarn/sendOrderInfoMsg',
      params,
    });
  },
  // 订单状态_王杰
  getOrderStatus(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/orderInfo/status',
      params,
    });
  },
  // 预存退费__刘鹏
  orderRefundWallet(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-edu/orderRefund/wallet',
      params,
    });
  },
  // 根据课价id,获取实时原价__刘鹏
  getOriginalPriceByPriceItemId(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/priceItem/getOriginalPriceByPriceItemId',
      params,
    });
  },
  // 退费-计算溢价金额__龙耀东
  calcPremiumMoney(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderRefund/calcPremiumMoney',
      params,
    });
  },
  // edu-退费-学员退费提交_杨武
  refundOrderSubmit(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-edu/orderRefund/refundOrderSubmit',
      params,
    });
  },
  // edu-结转-学员结转提交_杨武
  transferOrderSubmit(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-edu/orderRefund/transferOrderSubmit',
      params,
    });
  },
  orderRefundGoodsList(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-edu/orderRefund/goods/list',
      params,
    });
  },
  // 导入学员购课信息_宁左坤
  importStudentCurriculum(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/import/curriculum',
      params,
    });
  },
  // 导入班级_方季惟
  importClassInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/import/class',
      params,
    });
  },
  // 确认收入
  confirmInCome(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/confirmInCome',
      params,
    });
  },
  // 确认支出
  confirmOutgo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/confirmOutgo',
      params,
    });
  },
  // 导入测评报告
  importEvaluation(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/import/evaluation',
      params,
    });
  },
  // 课堂点评-成长记录列表
  companyArchivesList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/archives/companyArchivesList',
      params,
    });
  },
  // 排课下的点评记录
  queryCompanyCourseArrangeArchivesPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/archives/queryCompanyCourseArrangeArchivesPage',
      params,
    });
  },
  // 查询档案记录类型(分页)
  archivesTypePage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/archivesType/page',
      params,
    });
  },
  // 阶段测评-测评中心报告联合查询
  stageTestUnionQuery(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/student/stageTestUnionQuery',
      params,
    });
  },
  // 删除测评报告
  evaluationDelete(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/evaluation/delete',
      params,
    });
  },
  // 删除阶段测评信息
  archivesStageTestDelete(params) {
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-edu/archivesStageTest/delete?archivesId=${params.id}`,
    });
  },
  // 分页查询钱包
  findWalletCampusInfoPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/wallet/findWalletCampusInfoPage',
      params,
    });
  },
  // 分页查询校区下的学员钱包详情
  findWalletCampusDetailInfoPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/wallet/findWalletCampusDetailInfoPage',
      params,
    });
  },
  // 查询总金额
  findTotalMoney(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/wallet/findTotalMoney',
      params,
    });
  },
  // 导出校区钱包信息
  exportWalletCampusInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/wallet/exportWalletCampusInfo',
      params,
    });
  },
  // 导出校区中学员的钱包详情
  exportWalletCampusDetailInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/wallet/exportWalletCampusDetailInfo',
      params,
    });
  },
  // 作废订单_刘鹏
  orderInfoInvalidOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/invalidOrder',
      params,
    });
  },
  // 取消订单_刘鹏
  cancelOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/cancelOrder',
      params,
    });
  },
  // 退费订单详情_刘鹏
  refundOrderInfoPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderRefund/refundOrderInfoPage',
      params,
    });
  },
  // 撤销课消
  cancelCourseCharge(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/cancelCourseCharge',
      params,
    });
  },
  // 撤销课消2
  cancelCourseConsume(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/cancelCourseConsume',
      params,
    });
  },
  // 收费管家--获取机构商户信息 曹兵
  sfgjGetSfgjInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/sfgj/getSfgjInfo',
      params,
    });
  },
  // 收费管家--开通收费管家 曹兵
  sfgjOpenSfgj(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/sfgj/openSfgj',
      params,
    });
  },
  // 获取订单列表
  getOrderList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/page',
      params,
    });
  },
  // 获取退费订单列表
  getRefundOrderList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderRefund/list',
      params,
    });
  },
  // 获取课程列表
  getCourseList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/curriculum/page',
      params,
    });
  },
  // 根据学员Id获取课程列表
  getCourseListByStuId(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/curriculum/findCurriculumInfoByStudentId',
      params,
    });
  },
  // 课价列表
  getPriceitemList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/curriculum/curriculumPriceItemList',
      params,
    });
  },
  // 同课价学员列表
  getClassStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/studentsByPriceItemId/page',
      params,
    });
  },
  // 更多价学员列表
  moreStudents(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classStudent/moreStudents/page',
      params,
    });
  },
  // 教室列表
  getClassroomList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classRoom/list',
      params,
    });
  },
  // 新教室列表
  getClassroomnewList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/classRoom/list',
      params,
    });
  },
  // 分段视频查询
  segmentVideoList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/segmentVideoList',
      params,
    });
  },
  // 制作视频
  makeAVideo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/moment/makeVideo',
      params,
    });
  },
  // 班级是否关联价格
  checkClassRelationPrice(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/classInfo/checkClassRelationPrice',
      params,
    });
  },
  // 任务中心导入任务列表
  taskImportPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/import/taskImportPage',
      params,
    });
  },
  // 获取公众号二维码
  getWxMpCode() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/receiptTemplate/getWxMpCode',
    });
  },
  // 转pdf
  html2pdf(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/pdf/html2pdf',
      params,
    });
  },
  html2pdf2(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/pdf/html2pdf2',
      params,
    });
  },
  // 获取打印模板配置
  receiptTemplateInfo(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/receiptTemplate/info',
      params,
    });
  },
  // 保存打印模板配置
  receiptTemplateSave(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/receiptTemplate/save',
      params,
    });
  },
  // 获取收据对应的模板
  getPrintSnap(id, companyId) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/public/receipt/snapInfoByPaymentGroupId?paymentGroupId=${id}&companyId=${companyId}`,
    });
  },
  // 获取课时包列表
  findUniversalCardList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/cardInfo/findUniversalCardList',
      params,
    });
  },
  // 查询课时包价格列表
  findUniversalCardInfoDiscountPackage(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/cardInfo/findUniversalCardInfoDiscountPackage',
      params,
    });
  },
  // 获取测评模板列表
  evaluationTemplateList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/evaluationTemplate/list',
      params,
    });
  },
  // 查询排课的学员
  getCourseStudentsByRollCall(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/courseSign/getCourseStudentsByRollCall',
      params,
    });
  },
  // 查询单个排课的学员
  getCourseStudentPreview(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/courseSign/getCourseStudentPreview',
      params,
    });
  },
  // 批量点名
  courseSignBatch(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/batch',
      params,
    });
  },
  // 取消单个学员的点名
  cancelSingle(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/cancelSingle',
      params,
    });
  },
  // 单个学员的点名
  courseSignSingle(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/single',
      params,
    });
  },
  // 单个学员修改备注
  modifySingleRemark(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/modifySingleRemark',
      params,
    });
  },
  findStudentCurriculumCard(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/courseSign/findStudentCurriculumCard',
      params,
    });
  },
  // 批量修改班级助教-
  batchModifyClassAssistant(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/batchModifyClassAssistant',
      params,
    });
  },
  // 批量修改班级上课老师
  batchModifyClassTeahcer(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/batchModifyClassTeahcer',
      params,
    });
  },
  // 批量修改班级教室
  batchModifyClassRoom(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/batchModifyClassRoom',
      params,
    });
  },
  // 查询学员储值卡总账户详情
  queryStudentStoredCardAccount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardAccount/queryStudentStoredCardAccount',
      params,
    });
  },
  // 检查校区是否开启商户
  checkCampusMerchant(id) {
    return app.http.ajax({
      method: 'GET',
      url: `/api/cs-pc-edu/funds/checkCampusMerchant?campusId=${id}`,
    });
  },
  // 收款结算分摊
  proportionPayment(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/proportionPayment',
      params,
    });
  },
  // 在线支付
  onlinePayment(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/onlinePayment',
      params,
    });
  },
  // 查询支付组
  findPaymentGroup(params) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-edu/orderInfo/findPaymentGroup?groupId=${params.groupId}&orderId=${params.orderId}`,
    });
  },
  // 在线支付轮询
  onlinePaymentPoll(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/onlinePaymentPoll',
      params,
    });
  },
  // 根据机构手机号查询机构下的储值卡信息
  getStoredCardAccounts(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardAccount/getStoredCardAccounts',
      params,
    });
  },
  // 储值卡充值
  storedCardRecharge(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/storedCardRecharge',
      params,
    });
  },
  // 储值卡充值
  getStoredCardStudent(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/storedCardAccount/getStoredCardStudent',
      params,
    });
  },
  // 计算赠送金额
  calculateAmount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/storedCardRecharge/calculateAmount',
      params,
    });
  },
  // 发送储值卡支付验证码
  sendStoredCardSmsCode(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/sendStoredCardSmsCode',
      params,
    });
  },
  // 校验储值卡支付验证码
  verifyStoredCardSmsCode(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/verifyStoredCardSmsCode',
      params,
    });
  },
  // 查询存在欠费订单(需要补交的),如有多个则返回创建时间最新小的-方季惟
  findOweFeeByStudentId(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/findOweFeeByStudentId',
      params,
    });
  },
  // 欠费课程列表-方季惟
  oweList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/curriculum/oweList',
      params,
    });
  },
  // 计算实付金额
  utilsCalculatePayFact(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-edu/utils/calculate/payFact',
      params,
    });
  },
  // 查询机构业绩归属人规则
  findBelongerRule(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-edu/achievementBelongerRule/findBelongerRule',
      params,
    });
  },
  // 查询学员积分
  promotionValidPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/promotion/validPage',
      params,
    });
  },
  // 前台收费通用上课卡_王杰
  frontDeskUniversal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/frontDeskUniversal',
      params,
    });
  },
  // 欠费课时包查询——王杰
  oweUniversalCard(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/cardInfo/oweUniversalCard',
      params,
    });
  },
};
